//@flow
import * as React from 'react';
import type {spinnerIsShown} from "../../../../services/flowTypes/appFlowTypes";
import type {searchIcoIsClicked} from "../../../../services/flowTypes/componentFlowTypes";
import UsersFetcher from "./UsersFetcher/UsersFetcher";
import ConnectedUsersSearchInput from "./ConnectedUsersSearchInput/ConnectedUsersSearchInput";
import UsersFilters from "./UsersFilters";

type Props = {};
type State = {
  spinnerIsShown: spinnerIsShown,
  searchIcoIsClicked: searchIcoIsClicked,
};

class UsersSearchBox extends React.Component <Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      spinnerIsShown: false,
      searchIcoIsClicked: false
    };
  }
  handleResponse = () => {
    this.setState({
      spinnerIsShown: false,
      searchIcoIsClicked: false
    });
  };
  showSpinner = () => {this.setState({spinnerIsShown: true})};
  handleSearchIcoClick = () => {this.setState({searchIcoIsClicked: true})};
  render() {
    return (
      <>
        <UsersFetcher
          showSpinner={this.showSpinner}
          handleResponse={this.handleResponse}
          searchIcoIsClicked={this.state.searchIcoIsClicked}
        />
        <ConnectedUsersSearchInput
          handleSearchIcoClick={this.handleSearchIcoClick}
          spinnerIsShown={this.state.spinnerIsShown}
        />
        <UsersFilters/>
      </>
    );
  }
}

export default UsersSearchBox;    